<template>
  <el-container>
    <el-header>
      <div style="width:400px;">
        <img src="@/assets/images/logo.png" height="26px" style="float:left;margin-top: 10px; margin-left: 2px;" />
        <div style="float: left; margin: 0 0 0 10px;font-size: 23px;vertical-align: bottom;"></div>
        <div style="float: left; margin: 0 0 0 10px;">IoT设备管控平台</div>
      </div>
      <div class="navRight">
        <ul>
          <li><el-icon>
              <Bell />
            </el-icon></li>
          <li>
            <el-popover placement="bottom" width="350">
              <template #reference>
                <div style="width:100%;height:100%">
                  <el-icon>
                    <User />
                  </el-icon>
                </div>
              </template>
              <!-- el-popover控件关联的显示内容 -->
              <div>
                <el-avatar :size="50" style="margin:20px;background-color: #409eff;"> {{ currentUserInfo?.loginName }}
                </el-avatar>
                <el-descriptions title="" :column="1" :border="true">
                  <el-descriptions-item :label-width="140" label="登录帐号：">{{ currentUserInfo?.loginAccount
                  }}</el-descriptions-item>
                  <el-descriptions-item label="用户名称：">{{ currentUserInfo?.realName }}</el-descriptions-item>
                  <el-descriptions-item label="所属机构：">{{ currentUserInfo?.orgName }}</el-descriptions-item>
                  <el-descriptions-item label="过期时间：">
                    <el-tag size="small">{{ utils.formatDate(currentUserInfo?.expirationDate, "YYYY-MM-DD") }}</el-tag>
                  </el-descriptions-item>
                  <el-descriptions-item label="当前角色：">{{ currentUserInfo?.roleName }}</el-descriptions-item>
                  <el-descriptions-item label="Email：">{{ currentUserInfo?.email }}</el-descriptions-item>
                  <el-descriptions-item label="联系电话：">{{ currentUserInfo?.phoneNo }}</el-descriptions-item>
                  <el-descriptions-item label="状态：">
                    <el-tag v-if="currentUserInfo?.status == 0" label="正常" type="success" effect="plain">正常</el-tag>
                    <el-tag v-else type="info" effect="plain">停用</el-tag>
                  </el-descriptions-item>
                </el-descriptions>
              </div>
              <div style="margin:10px 0;">
                <el-button type="primary" :icon="Lock" @click="handler.editPassword">修改密码</el-button>
              </div>
            </el-popover>
          </li>
          <li @click="loginOut" style="width:130px;">
            <el-icon style=" margin: 3px;">
              <SwitchButton></SwitchButton>
            </el-icon>
            <span style="position: relative; top:-2px;">退出系统</span>
          </li>
        </ul>
      </div>
    </el-header>

    <el-container>
      <NavMenu></NavMenu>
      <el-main>
        <KeepAlive>
          <RouterView name="mainFrame"></RouterView>
        </KeepAlive>
      </el-main>
    </el-container>
  </el-container>

  <el-dialog v-model="dialogFormVisible" title="修改密码" width="400">
    <el-form :inline="true" :model="form" :label-position="top" label-width="auto" :rules="rules" status-icon
      ref="dataFormRef">
      <el-form-item label="新密码" prop="password">
        <el-input v-model="form.password" type="password" autocomplete="off" class="el-input-width" />
      </el-form-item>
      <el-form-item label="新密码" prop="confirmPassword">
        <el-input v-model="form.confirmPassword" type="password" autocomplete="off" class="el-input-width" />
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="handler.changePassword">保存</el-button>
      </div>
    </template>
  </el-dialog>

</template>


<script setup>
import NavMenu from './NavMenu.vue';
import { ref, reactive } from 'vue';
import { SwitchButton, Bell, User, Lock } from '@element-plus/icons-vue';
import { ElMessageBox, ElMessage } from 'element-plus'
import { useRouter } from 'vue-router';
import { authApi } from "@/api/auth-api.js";
import { userApi } from '@/api/user-api.js';
import { getUserInf } from '@/shard/login-info-manager.js';
import utils from "@/utils/utils.js";
import CryptoJS from 'crypto-js';


const router = useRouter();
const currentUserInfo = ref({});
const dialogFormVisible = ref(false);
const dataFormRef = ref(null);

//表单对象
//SysUserPO
const form = reactive({
  id: getUserInf().userId,
  password: null,
  confirmPassword: null
});
const resetForm = () => {
  dataFormRef.value?.resetFields();
};

const validateConfirmPassword = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请再次输入密码'))
  } else if (value !== form.password) {
    callback(new Error('两次输入密码不一致!'))
  } else {
    callback()
  }
}

const rules = {
  password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
  confirmPassword: [{ required: true, validator: validateConfirmPassword, trigger: 'blur' }]
};


userApi.getUserDetail({ userId: getUserInf().userId }).then((response) => {
  if (response.data.errorCode === "00000") {
    currentUserInfo.value = response.data.result;
  }
});


const loginOut = () => {
  ElMessageBox.confirm(
    '确认要退出吗?',
    '确认?',
    {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning',
    }
  ).then(() => {
    authApi.logout()
      .then((response) => {
        if (response.data && response.data.errorCode == "00000") {
          router.push({ name: 'Login' });
        }
      }).catch(function (error) {
        console.log(error);
      });
  })
}

//UI界面逻辑
const handler = {
  editPassword() {
    resetForm();
    dialogFormVisible.value = true;
  },
  changePassword() {
    dataFormRef.value.validate((valid) => {
      if (valid) {
        form.password = CryptoJS.SHA256(form.password).toString();
        userApi.changePassword(form).then((response) => {
          if (response.data.errorCode === "00000") {
            ElMessage({ message: '密码修改成功', type: 'success' });
            dialogFormVisible.value = false;
          } else {
            ElMessage.error("系统出错[errorCode:" + response.data.errorCode + "]");
          }
        })
      }
    });
  }
}
</script>


<style>
body {
  padding: 0;
  margin: 0;
  overflow: auto;
}

.navRight {
  width: auto;
  position: absolute;
  top: 0;
  right: 0;
}

.navRight ul {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0 0 0 140px;
}

.navRight ul li {
  float: left;
  padding: 0 1px;
  font-size: 15px;
  min-width: 60px;
  text-align: center;
  cursor: pointer;
}

.navRight ul li:hover {
  float: left;
  background-color: #409eff;
}

.contaier {
  height: 100vh;
  margin: 0;
}

/*头部 */
.el-container>.el-header {
  background-color: #333399;
  color: white;
  height: 50px;
}

.el-container>.el-header>div {
  height: 50px;
  line-height: 50px;
  vertical-align: middle;
}

/* 左侧菜单区 */
.el-container>.el-aside {
  height: calc(100vh - 50px);
  width: auto;
  overflow: auto;
}

.el-container>.el-main {
  background-color: #F0F2F5;
  padding: 5px;
  overflow: auto;
}
</style>